import React from 'react';

/**
 * Mission 10 status badge / pill. Maps a status to the canonical 3-shade
 * token set (text on tint) from index.css. `StatusPill` is an alias — same
 * visual, clearer name at call sites that render a live status.
 */
export type BadgeStatus = 'neutral' | 'success' | 'warning' | 'error' | 'info';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  status?: BadgeStatus;
  icon?: React.ReactNode;
}

export const Badge: React.FC<BadgeProps> = ({
  status = 'neutral',
  icon,
  className = '',
  children,
  ...rest
}) => {
  const cls = ['admin-badge', `admin-badge--${status}`, className].filter(Boolean).join(' ');
  return (
    <span className={cls} {...rest}>
      {icon}
      {children}
    </span>
  );
};

/** Alias — semantically a status pill; identical visual to Badge. */
export const StatusPill = Badge;
